import { createApp } from 'vue'
import App from './App.vue'
import "./assets/scss/index.scss";

createApp(App).mount('#app')
